import { ROUTE_PATH_RESOURCE_CENTRE } from '../../constants';
import { ProtectionPageTranslations } from '../types';

export const translations: ProtectionPageTranslations = {
  docTitle: 'Perte du portefeuille',
  pageTitle: 'Perte du portefeuille',
  featureList: [
    {
      // 'key' MUST BE the same as array index
      key: '0',
      heading: 'La perte de votre portefeuille ne devrait pas vous faire paniquer : nous sommes là pour vous.',
      summary: [
        '<p>Si vos cartes de paiement ont été perdues ou volées, veuillez vous connecter à notre site Web ou nous appeler dans les plus brefs délais afin de recevoir immédiatement la protection et l’aide dont vous avez besoin.',
        'Ce service est accessible 24 heures sur 24, 7 jours sur 7, partout dans le monde.</p>',
        '<p class="text-contact-number">',
        'Sans frais (Amérique du Nord)',
        '<a tabindex="0" href="tel:+1-866-327-3078" class="text-nowrap">1-866-327-3078</a>',
        '</p>',
        '<p class="text-contact-number">',
        'À frais virés (International)',
        '<a tabindex="0" href="tel:+1-647-837-5412" class="text-nowrap">1-647-837-5412</a>',
        '</p>'
      ].join('\n')
    },
    {
      key: '1',
      heading: '',
      summary: [
        '<h2 class="feature-item-heading">Annulation de carte en un seul clic ou un seul appel</h2>',
        '<p>Appelez-nous pour annuler vos cartes perdues ou volées, ou annulez-les en ligne. Nous nous chargerons d’informer les émetteurs de vos cartes.</p>',
        
        '<h2 class="feature-item-heading">Alerte à la fraude</h2>',
        '<p>Au besoin, vous pouvez choisir de faire accompagner votre dossier de crédit d’un avis d’alerte à la fraude afin de signaler aux prêteurs que vous pourriez avoir été victime d’un vol d’identité et qu’ils doivent prendre des précautions supplémentaires avant de vous accorder une nouvelle marge de crédit.</p>',
        
        '<h2 class="feature-item-heading">Fonds d’urgence</h2>',
        '<p>Si vous vous retrouvez coincé à plus de 160 km de votre domicile en raison de la perte ou du vol d’une carte',
        'de paiement, vous pouvez demander le virement d’une avance de fonds d’urgence pouvant aller jusqu’à 2500 $ dans',
        'un emplacement à proximité. Le montant de l’avance sera porté à la carte de crédit de votre choix.</p>',
        
        '<p><strong>Besoin d’aide pour remplacer les autres cartes contenues dans votre portefeuille?</strong></p>'
      ].join('\n'),
      action: {
        resourceCentre: {
          to: ROUTE_PATH_RESOURCE_CENTRE,
          children: 'Centre de ressources'
        }
      }
    }
  ]
};
